import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './CallToAction.scss';
import { Button } from '@spotahome/ui-library';
import '@spotahome/ui-library/lib/components/Button.css';

const CallToAction = props => {
  const className = classNames('cta', {
    'cta--full': props.full
  });

  return (
    <Button
      className={className}
      onClick={props.onClick}
      href={props.link}
      size="big"
    >
      {props.children}
    </Button>
  );
};

CallToAction.propTypes = {
  link: PropTypes.string.isRequired,
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  full: PropTypes.bool,
  onClick: PropTypes.func
};

CallToAction.defaultProps = {
  full: false,
  onClick: () => {}
};

export default CallToAction;
